import { gql } from '__generated__';

export const AUTH_CHALLENGE_FIELDS = gql(/* GraphQL */ `
  fragment AuthChallenge on LoginChallengeResponse {
    challengeName
    session
    challengeParameters {
      requiredAttributes
      USER_ID_FOR_SRP
      userAttributes
    }
  }
`);
